/** VUCA + insecurity patterns surfaced in brain dump / guided reflection insights */

export const BEHAVIOR_PATTERN_KEYS = [
  "Volatility",
  "Uncertainty",
  "Complexity",
  "Ambiguity",
  "Insecurity"
];

export const BEHAVIOR_PATTERNS = {
  Volatility: {
    counter: "Vision",
    counterLine: "Vision counters volatility",
    guide:
      "Anchor with one clear, compelling intention or priority that can stay steady while the environment shifts."
  },
  Uncertainty: {
    counter: "Understanding",
    counterLine: "Understanding counters uncertainty",
    guide:
      "Reduce unknowns with one small step to learn—ask one person, run one experiment, or gather one fresh fact instead of guessing."
  },
  Complexity: {
    counter: "Clarity",
    counterLine: "Clarity counters complexity",
    guide:
      "Simplify—name one core objective or break the tangle into one next piece you can act on."
  },
  Ambiguity: {
    counter: "Agility",
    counterLine: "Agility counters ambiguity",
    guide:
      "Stay flexible—try one small experiment, allow a pivot, or hold two possibilities lightly without forcing a final answer today."
  },
  Insecurity: {
    counter: "Short-term goal",
    counterLine: "A short-term goal counters insecurity",
    guide:
      "Set one achievable goal for today or this week that builds competence or connection—not fixing self-worth in one step."
  }
};

export function canonicalBehaviorPattern(value) {
  const v = String(value || "").trim();
  if (!v) return "";
  const match = BEHAVIOR_PATTERN_KEYS.find((key) => key.toLowerCase() === v.toLowerCase());
  return match || "";
}

export function getBehaviorPatternMeta(pattern) {
  const key = canonicalBehaviorPattern(pattern);
  if (!key) return null;
  return { key, ...BEHAVIOR_PATTERNS[key] };
}
